import "./styles.scss";

import React from "react";
import Slider from "react-slick";
import clsx from "clsx";

const CardSlider = ({ children, breakpoint }) => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
  };

  return (
    <Slider
      {...settings}
      className={clsx("card-slider", breakpoint && `d-${breakpoint}-none`)}
    >
      {children}
    </Slider>
  );
};

export default CardSlider;
